// extracted by mini-css-extract-plugin
export var active = "_e0-7";
export var container = "_e0-0";
export var evenWidth = "_e0-4";
export var large = "_e0-5";
export var outlet = "_e0-8";
export var slide = "_e0-2";
export var small = "_e0-6";
export var tab = "_e0-3";
export var tabs = "_e0-1";